import { render } from "./divider-line.vue?vue&type=template&id=1bd89db4"
import script from "./divider-line.vue?vue&type=script&lang=js"
export * from "./divider-line.vue?vue&type=script&lang=js"

import "./divider-line.vue?vue&type=style&index=0&id=1bd89db4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__